import create from 'zustand/vanilla';
import { persist, createJSONStorage } from "zustand/middleware";
import store from "@/modules/MuiDialog/store";

interface UserState {
    id: string;
    nickname: string;
    email: string;
    phone_number?: string;
    invitation_code?: string;
    gender?: string;
    age_group?: string;
    image_url?: string;
}

interface UserStatePatch {
    nickname?: string;
    email?: string;
    phone_number?: string;
    invitation_code?: string;
    gender?: string;
    age_group?: string;
    image_url?: string;
}

export interface UserStore extends UserState {
    setUserInfo: (user: UserState) => void;
    patchUserInfo: (user: UserStatePatch) => void;
    clearUser: () => void;
}

const initializeState: UserState = {
    id: '',
    nickname: '',
    email: '',
    phone_number: '',
    invitation_code: '',
    gender: '',
    age_group: '',
    image_url: '',
}

export const userStore = create<UserStore>()(persist((set) => ({
    ...initializeState,

    setUserInfo: (user: UserState) => {
        set((state) => (user))
    },

    patchUserInfo: (user: UserStatePatch) => {
        set((state) => ({
            nickname: user?.nickname || state.nickname,
            email: user?.email || state.email,
            phone_number: user?.phone_number || state.phone_number,
            invitation_code: user?.invitation_code || state.invitation_code,
            gender: user?.gender || state.gender,
            age_group: user?.age_group || state.age_group,
            image_url: user?.image_url || state.image_url,
        }))
    },

    clearUser: () => {
        set(initializeState);
    }
}), {
    name: 'user-storage',
    storage: createJSONStorage(() => sessionStorage),
}));

const { getState, setState, subscribe, destroy } = userStore;

export default userStore;